module.exports = __webpack_public_path__ + "img/5.3dcec27b.png";